import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './BookDemoButton.css';

const CALENDAR_URL =
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ25PYcnS8Dc8J-Cy4G0D4xgy-aD6LlI0LZzd3HMmVjcWmuhRADwCLxj7M8g2KxvGmZZ3ukiPl4q?gv=true';

const BookDemoButton = ({ label = 'Find Out How' }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="btn btn-lg btn-primary book-demo-btn"
      >
        {label}
      </button>

      {open && createPortal(
        <div className="book-demo-overlay" onClick={() => setOpen(false)}>
          <div className="book-demo-modal" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="book-demo-modal-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              &times;
            </button>
            <iframe
              src={CALENDAR_URL}
              title="Book a Demo"
              className="book-demo-iframe"
            />
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default BookDemoButton;
